import React from "react";

//import stock
import hw from "../img/Hardware-collage.png";
import sw from "../img/sw-collage.jpg";
import swMobile from "../img/sw-mobile.jpg"
import stock11 from "../img/lotScreen.png";


import bot1 from "../img/Bot1.png"
import bot2 from "../img/Bot2.jpg"
import bot3 from "../img/Bot3.jpeg"
import bot4 from "../img/Bot4.jpeg"
import botTeam from "../img/BotTeam.jpeg"

import web1  from "../img/web1.png";
import web2  from "../img/web2.png";
import web3  from "../img/web3.png";
import web4  from "../img/web4.png";
import web5  from "../img/web5.png";
import web6  from "../img/web6.png";
import web7  from "../img/web7.png";

import mob1 from "../img/mobile1.png";
import mob2 from "../img/mobile2.png";
import mob3 from "../img/mobile3.png";
import mob4 from "../img/mobile4.png";
import mob5 from "../img/mobile5.png";
import mob6 from "../img/mobile6.png";
import mob7 from "../img/mobile7.png";
import mob8 from "../img/mobile8.png";
import mob9 from "../img/mobile9.png";

//
// import stock1 from "../img/image2.jpg";
// import stock2 from "../img/image3.jpg";
// import stock3 from "../img/image4.jpg";
// import stock4 from "../img/image5.jpg";
// import stock5 from "../img/image6.jpg";

class Portfolio extends React.Component {
  render() {
    return (
      <section id="work" className="portfolio-mf sect-pt4 route">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box text-center">
                <h3 className="title-a">Portfolio</h3>
                <p className="subtitle-a">
                  These are Projects which I have done during my undergraduate period.
                </p>
                <div className="line-mf"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <a href={mob1} data-lightbox="gallery-vmarine">
                  <div className="work-img">
                    <img src={swMobile} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-9">
                        <h2 className="w-title">Tea Tracker - Mobile</h2>
                        <div className="w-more">
                          <h2 className="w-description">Two separate mobile applications were developed to track the production, purchasing, and managerial functions of an orthodox tea manufacturing plant.</h2>
                          <span className="w-ctegory">
                             Flutter, NodeJS/ExpressJS, MySQL, SQL-Lite
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={mob2}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={mob3}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={mob4}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={mob5}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={mob6}
                  data-lightbox="gallery-vmarine"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={mob7}
                    data-lightbox="gallery-vmarine"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={mob8}
                    data-lightbox="gallery-vmarine"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={mob9}
                    data-lightbox="gallery-vmarine"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={web1} data-lightbox="gallery-todo">
                  <div className="work-img">
                    <img src={sw} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-9">
                        <h2 className="w-title">Tea Tracker - Web</h2>
                        <div className="w-more">
                          <h2 className="w-description">A web application were developed to support managerial persons of an orthodox tea manufacturing plant. <br/>The main functions are Graphical Dashboard, Generating Reports, Machinery and equipment, supplier, user management.</h2>
                          <span className="w-ctegory">
                             React JS, NodeJS/ExpressJS, MySQL
                          </span>
                          {/*} / <span className="w-date">18 Sep. 2018</span>*/}
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                    href={web2}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={web3}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={web4}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={web5}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={web6}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                    href={web7}
                    data-lightbox="gallery-todo"
                    style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <a href={botTeam} data-lightbox="gallery-aguadeluz">
                  <div className="work-img">
                    <img src={hw} alt="" className="img-fluid" />
                  </div>
                  <div className="work-content">
                    <div className="row">
                      <div className="col-sm-9">
                        <h2 className="w-title">Nurse Bot & Piller Machine</h2>
                        <div className="w-more">
                          <h2 className="w-description">An automated system was developed to regulate intra-ward medicine delivery for inpatients in hospitals</h2>
                          <span className="w-ctegory">
                            AVR microcontroller programming, micro C
                          </span>{" "}
                        </div>
                      </div>
                      <div className="col-sm-3">
                        <div className="w-like">
                          <span className="ion-ios-plus-outline"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a
                  href={bot1}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={bot2}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={bot3}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                <a
                  href={bot4}
                  data-lightbox="gallery-aguadeluz"
                  style={{ display: "none" }}
                >
                  jsx-a11y/anchor-has-content warning
                </a>
                {/*<a*/}
                {/*  href={b}*/}
                {/*  data-lightbox="gallery-aguadeluz"*/}
                {/*  style={{ display: "none" }}*/}
                {/*>*/}
                {/*  jsx-a11y/anchor-has-content warning*/}
                {/*</a>*/}
              </div>
            </div>

            {/*<div className="col-md-4">*/}
            {/*  <div className="work-box">*/}
            {/*    <a href={stock} data-lightbox="gallery-medlingos">*/}
            {/*      <div className="work-img">*/}
            {/*        <img src={stock} alt="" className="img-fluid" />*/}
            {/*      </div>*/}
            {/*      <div className="work-content">*/}
            {/*        <div className="row">*/}
            {/*          <div className="col-sm-8">*/}
            {/*            <h2 className="w-title">Lorem Ipsum</h2>*/}
            {/*            <div className="w-more">*/}
            {/*              <span className="w-ctegory">*/}
            {/*                Bootstrap ReactJS GoogleAPI*/}
            {/*              </span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*          <div className="col-sm-4">*/}
            {/*            <div className="w-like">*/}
            {/*              <span className="ion-ios-plus-outline"></span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock1}*/}
            {/*      data-lightbox="gallery-medlingos"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock2}*/}
            {/*      data-lightbox="gallery-medlingos"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock3}*/}
            {/*      data-lightbox="gallery-medlingos"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock4}*/}
            {/*      data-lightbox="gallery-medlingos"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock5}*/}
            {/*      data-lightbox="gallery-medlingos"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="col-md-4">*/}
            {/*  <div className="work-box">*/}
            {/*    <a href={stock} data-lightbox="gallery-smth">*/}
            {/*      <div className="work-img">*/}
            {/*        <img src={stock} alt="" className="img-fluid" />*/}
            {/*      </div>*/}
            {/*      <div className="work-content">*/}
            {/*        <div className="row">*/}
            {/*          <div className="col-sm-8">*/}
            {/*            <h2 className="w-title">Lorem Ipsum</h2>*/}
            {/*            <div className="w-more">*/}
            {/*              <span className="w-ctegory">MERN</span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*          <div className="col-sm-4">*/}
            {/*            <div className="w-like">*/}
            {/*              <span className="ion-ios-plus-outline"></span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock1}*/}
            {/*      data-lightbox="gallery-smth"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock2}*/}
            {/*      data-lightbox="gallery-smth"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock3}*/}
            {/*      data-lightbox="gallery-smth"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock4}*/}
            {/*      data-lightbox="gallery-smth"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock5}*/}
            {/*      data-lightbox="gallery-smth"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className="col-md-4">*/}
            {/*  <div className="work-box">*/}
            {/*    <a href={stock} data-lightbox="gallery-mf">*/}
            {/*      <div className="work-img">*/}
            {/*        <img src={stock} alt="" className="img-fluid" />*/}
            {/*      </div>*/}
            {/*      <div className="work-content">*/}
            {/*        <div className="row">*/}
            {/*          <div className="col-sm-8">*/}
            {/*            <h2 className="w-title">Lorem Ipsum</h2>*/}
            {/*            <div className="w-more">*/}
            {/*              <span className="w-ctegory">*/}
            {/*                HTML5 CSS3 Bootstrap MERN*/}
            {/*              </span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*          <div className="col-sm-4">*/}
            {/*            <div className="w-like">*/}
            {/*              <span className="ion-ios-plus-outline"></span>*/}
            {/*            </div>*/}
            {/*          </div>*/}
            {/*        </div>*/}
            {/*      </div>*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock1}*/}
            {/*      data-lightbox="gallery-mf"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock2}*/}
            {/*      data-lightbox="gallery-mf"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock3}*/}
            {/*      data-lightbox="gallery-mf"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock4}*/}
            {/*      data-lightbox="gallery-mf"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*    <a*/}
            {/*      href={stock5}*/}
            {/*      data-lightbox="gallery-mf"*/}
            {/*      style={{ display: "none" }}*/}
            {/*    >*/}
            {/*      jsx-a11y/anchor-has-content warning*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*</div>*/}
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
